import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6a82c4e3")

_pushScopeId("data-v-6a82c4e3")
const _hoisted_1 = /*#__PURE__*/_createVNode("h5", { class: "mb-2" }, "Pembayaran Terkini", -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_3 = { class: "d-flex justify-content-between" }
const _hoisted_4 = { class: "d-flex justify-content-between mt-3" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", {
  style: {"background-color":"#ffbaba","color":"#d8000c","text-align":"center","padding":"5px","display":"none"},
  id: "footer-recent-payment"
}, " No more data ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _createVNode("div", {
      class: "px-2",
      style: {"height":"500px","overflow-y":"auto"},
      onScroll: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.scroll && _ctx.scroll(...args)))
    }, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.invoices, (invoice) => {
        return (_openBlock(), _createBlock("div", {
          class: "list p-3",
          key: invoice.invoice_id
        }, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", null, [
              _createVNode("h6", {
                class: invoice.user_status === 'Inactive' ? 'text-danger' : 'text-primary',
                innerHTML: invoice.invoice_number + (invoice.user_status === 'Inactive' ? '<br><span class=\'badge bg-danger\'>Inactive User</span>' : '')
              }, null, 10, ["innerHTML"])
            ]),
            _createVNode("div", null, [
              _createVNode("div", {
                class: invoice.status == 'Lunas' ? 'gbadgesuc' : 'gbadgeerr'
              }, _toDisplayString(invoice.status), 3)
            ])
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode("div", null, [
              _createVNode("h6", null, _toDisplayString(invoice.type), 1)
            ]),
            _createVNode("div", null, [
              _createVNode("h6", null, "Rp. " + _toDisplayString(invoice.total_payment.toLocaleString()), 1)
            ])
          ])
        ]))
      }), 128))
    ], 32),
    _hoisted_5
  ]))
})